import { atom } from 'recoil';

export const showFooterState = atom({
  key: 'showFooterState',
  default: true,
});
